
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulatory-compliance",
      function () {
        return require("private-next-pages/regulatory-compliance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulatory-compliance"])
      });
    }
  